<template>
  <div class="upload_wrapper">
    <el-upload
      class="avatar-uploader"
      :data={folderName}
      :action="uploadAddr + 'upload/upload'"
      :show-file-list="false"
      :on-progress="isUploading"
      :on-success="handleAvatarSuccess"
      :on-error="isErrloading"
      :disabled="disabled"
      >
      <el-button slot="trigger" type="primary" :disabled="disabled">{{text}}</el-button>
    </el-upload>
  </div>

</template>
<script>
  // import {mapGetters} from 'vuex'
  import { Loading } from 'element-ui';
import { method } from 'lodash';
  export default {
    props: {
      disabled: {
        default: false
      },
      folderName: {},
      appendUrl: {
        default: ''
      },
      text: {
        default: ''
      },
      appendName: {
        default: ''
      },
      width: {
        default: ''
      },
      height: {
        default: 120
      },
      beforeUpload: {
        method: Function,
        default: () => {}
      }
    },
    data () {
      return {
        picAddr: '',
        fileUrl: '',
        fileName: '',
        loading:false
      }
    },
    watch: {
      appendUrl (val1,val2) {
        if (val1) {
          this.fileUrl = this.uploadAddr+val1
        }
      },
      appendName (val1,val2) {
        if (val1) {
          console.log(val1)
          this.fileName = val1
        }
      }
    },
    created () {
    },
    activated() {
      console.log(this.appendUrl)
      if (this.appendUrl) {
        this.fileUrl = this.uploadAddr+this.appendUrl
      } else {
        this.fileUrl = ''
      }
      this.fileName = this.appendName
    },
    methods: {
      handleAvatarSuccess (res, file) {
        this.fileUrl = file.response.file.url
        this.fileName = file.response.file.fileName
        this.$emit('changed', this.fileUrl.replace(this.uploadAddr, ''),this.fileName)
        this.loading.close()
      },
      isErrloading(){
        this.$message('上传失败');
        this.loading.close()
      },
      beforeAvatarUpload (file) {
        // const isLt100M = file.size / 1024 / 1024 < 300
        // if (!isLt100M) {
        //   this.$message.error('上传图片大小不能超过 100MB!')
        // }
        if (this.beforeUpload) {
          return this.beforeUpload()
        } 
        return isLt100M
      },
      isUploading(){
        this.loading = Loading.service({
          lock: true,
          text: '保存中......',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
    },
    computed: {
      headers () {
        return {
          Authorization: 'Bearer ' + window.localStorage.getItem('token')
        }
      },
      getfile () {
        return this.uploadAddr + this.fileUrl.replace(this.uploadAddr, '')
      },
      uploadAddr() {
        return this.$store.getters.uploadAddr
      }
      // ...mapGetters(['picAddr'])
    }

  }
</script>
<style lang="scss" scoped>
  .upload_wrapper {
    .fileName {
      width: 100%;
      /*height: 150px;*/
    }

    .pic img {
      max-height: 160px;
      max-width: 100%;
    }

    .choose {
      display: flex;
      flex-direction: column;
      align-items: center;
      i {
        display: block;
        width: 42px;
        height: 43px;
        background-size: 42px 43px;
        background-image: url("../../assets/image/icon_plus.png");
      }
      .text {
        padding-top: 5px;
      }
    }
  }
</style>

